<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="dashboardRoute"
                                    >Portada</router-link
                                >
                            </li>
                            <li>
                                <span>Hoteles</span>
                            </li>
                            <li class="active">
                                <span>Lista de hoteles</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        Lista de hoteles
                    </h2>
                    <small>Gestionar hoteles</small>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Hoteles
                </div>
                <div class="panel-body">
                    <div class="m-b-md">
                        <div class="m-b-sm">
                            <button
                                class="btn btn-default"
                                type="button"
                                data-toggle="collapse"
                                data-target="#hotelListFilters"
                                aria-expanded="false"
                                @click="toggleFilter"
                                aria-controls="hotelListFilters"
                            >
                                Filtros
                                <i
                                    :class="
                                        'fa fa-caret-' +
                                            (filterFlag ? 'down' : 'up')
                                    "
                                ></i>
                            </button>
                            <router-link
                                class="btn btn-primary btn-outline pull-right"
                                tag="button"
                                :to="hotelNewRoute"
                            >
                                Crear <i class="fa fa-plus"></i
                            ></router-link>
                        </div>
                        <div class="collapse" id="hotelListFilters">
                            <div class="form">
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <label>Nombre</label>
                                        <custom-input
                                            tipo="text"
                                            :field="$v.filters.name"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Código</label>
                                        <custom-input
                                            tipo="text"
                                            :field="$v.filters.code"
                                        />
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Estado</label>
                                        <custom-input
                                            tipo="select"
                                            :field="$v.filters.status"
                                            :items="statuses"
                                        />
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <button
                                            type="button"
                                            class="btn btn-default"
                                            @click="clear"
                                        >
                                            Limpiar filtros
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            @click="search"
                                        >
                                            Aplicar filtros
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table
                            cellpadding="1"
                            cellspacing="1"
                            class="table table-bordered table-striped"
                        >
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Nombre</th>
                                    <th>Dirección</th>
                                    <th>Administrador</th>
                                    <th>Correo electrónico</th>
                                    <th>Celular</th>
                                    <th>Estado</th>
                                    <th style="width:6%">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="o in data" :key="o.id">
                                    <td align="center">
                                        <span>{{ o.code }}</span>
                                    </td>
                                    <td>
                                        <span>{{ o.name }}</span>
                                    </td>
                                    <td>
                                        <span>{{ o.address }}</span>
                                    </td>
                                    <td>
                                        <span>{{ o.manager }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.email }}</span>
                                    </td>
                                    <td align="center">
                                        <span>{{ o.phone }}</span>
                                    </td>
                                    <td align="center">
                                        <status-badge :status="o.status" />
                                    </td>
                                    <td align="center" class="action-cell">
                                        <div class="dropdown">
                                            <a
                                                type="button"
                                                class="dropdown-toggle"
                                                data-toggle="dropdown"
                                                ><i class="fa fa-gear"></i
                                            ></a>
                                            <ul
                                                class="dropdown-menu filedropdown m-l pull-right"
                                            >
                                                <li>
                                                    <a @click="goToEdit(o.id)"
                                                        >EDITAR</a
                                                    >
                                                </li>
                                                <li>
                                                    <a
                                                        @click="
                                                            toggleHotelState(
                                                                o.id,
                                                                o.status
                                                            )
                                                        "
                                                        >{{
                                                            o.status === 1
                                                                ? "INACTIVAR"
                                                                : "ACTIVAR"
                                                        }}</a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <paginator
                        :total-elements="totalElements"
                        :page-number="pageNumber"
                        :total-pages="totalPages"
                        :change-page="changePage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    DASHBOARD,
    HOTEL_EDIT,
    HOTEL_LIST,
    HOTEL_NEW
} from "../../router/routes";
import CustomInput from "../common/CustomInput.vue";
import StatusBadge from "../common/StatusBadge.vue";
import { maxLength } from "vuelidate/lib/validators";
import { hotelStatusList } from "../../util/selectOptions";
import { paginationMixin } from "../../util/paginationMixin";
import { filterMixin } from "../../util/filterMixin";
import Alert from "../../util/alert";
import HotelService from "../../services/HotelService";

export default {
    name: HOTEL_LIST.name,
    mixins: [paginationMixin, filterMixin],
    components: { CustomInput, StatusBadge },
    data: () => ({
        dashboardRoute: DASHBOARD.route,
        hotelNewRoute: HOTEL_NEW.route,
        data: [],
        statuses: hotelStatusList,
        filters: {
            name: null,
            code: null,
            status: null
        }
    }),
    validations: {
        filters: {
            name: { maxLength: maxLength(50) },
            code: { maxLength: maxLength(4) },
            status: {}
        }
    },
    methods: {
        async init() {
            const self = this;

            let activeState = {
                key: 1,
                value: "ACTIVO"
            };

            self.filters.status = activeState;

            self.getData({ status: activeState.key });
        },
        search() {
            this.$v.$touch();
            if (this.$v.$error) return;
            const self = this;

            const data = {
                ...self.filters,
                ...{
                    status: self.filters.status ? self.filters.status.key : null
                }
            };
            self.getData(data);
        },
        clear() {
            const self = this;
            self.filters.name = self.filters.code = self.filters.status = null;
            self.$v.$reset();
        },
        goToEdit(hotelId) {
            this.$router.push({
                path: HOTEL_EDIT.route.replace(":hotelId", hotelId)
            });
        },
        onToggleState(hotel) {
            const hotels = this.data.filter(o => {
                return o.id === hotel.id;
            });

            const hotelFiltered =
                hotels && hotels.length > 0 ? hotels[0] : null;
            const index = this.data.indexOf(hotelFiltered);
            this.$set(this.data, index, hotel);
        },
        async toggleHotelState(hotelId, source) {
            try {
                const status = source === 1 ? 2 : 1;
                const hotelUpdated = (
                    await HotelService.toggleHotelState(hotelId, status)
                ).data.payload;
                this.onToggleState(hotelUpdated);
            } catch (err) {
                Alert.mensajeError(err.message);
            }
        },
        async getData(params = {}, page = 1) {
            params.page = page - 1;
            params.size = this.pageSize;
            this.params = params;
            this.loading = true;
            const payload = (await HotelService.filterHotels(params)).data
                .payload;
            this.data = payload.content;
            this.totalPages = payload.totalPages;
            this.totalElements = payload.totalElements;
            this.pageNumber = payload.number + 1;
            this.loading = false;
        }
    },
    async mounted() {
        this.init();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/HotelList.vue